<div class="page-title-area">
    <img src="assets/images/essilor.png" alt="Page Background" class="page-bg">
    <div class="container">
        <div class="page-title-content">
            <h2>Digital Transformation</h2>
            <!-- <ul>
                <li><a routerLink="/">Home </a></li>
                <li class="active">Case Studies Details</li>
            </ul> -->
        </div>
    </div>

    <!--    <div class="page-shape">
        <div class="shape1"><img src="assets/images/shape/1.png" alt="shape" /></div>
        <div class="shape3"><img src="assets/images/shape/3.png" alt="shape" /></div>
        <div class="shape4"><img src="assets/images/shape/4.png" alt="shape" /></div>
        <div class="shape5"><img src="assets/images/shape/5.png" alt="shape" /></div>
        <div class="shape6"><img src="assets/images/shape/6.png" alt="shape" /></div>
    </div> -->
</div>

<section class="services-details-area ptb-100">
    <div class="container">
        <!-- <div class="row">
            <div class="col-12">
                <div class="services-img mb">
                    <img src="assets/images/case-details/1.jpg" alt="Image">
                </div>
            </div>

            <div class="col-12">
                <div class="services-details-text">
                    <h2>Joe’s Company Software Development Case</h2>
                    <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum  not only five centuries, but also the leap into.</p>
                    <p>There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable. If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text. All the Lorem Ipsum generators on the Internet tend to repeat predefined chunks as necessary, making this the first true generator on the Internet. It uses a dictionary of over 200 Latin words, combined with a handful of model sentence structures, to generate Lorem Ipsum which looks reasonable. The generated Lorem Ipsum is therefore always free from repetition, injected humour, or non-characteristic words etc. this the first true generator on the Internet. It uses a dictionary of over 200 Latin words, combined with a dictionary of over 200 Latin words, combined with a</p>
                    <p>There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable. If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text. All the Lorem Ipsum generators on the Internet tend to repeat predefined chunks as necessary, making this the first true generator on the Internet. It uses a dictionary of over 200 Latin words, combined with a handful of model sentence structures, to generate Lorem Ipsum which looks reasonable. The generated Lorem Ipsum is therefore always free from repetition, injected humour, or non-characteristic words etc generators on the Internet tend to repeat predefined chunks as necessary, making this the first generator dictionary of over 200 Latin words, combined with a.</p>
                </div>
            </div>
        </div> -->
<!--         <div class="section-title">
            <div style="display: flex; flex-direction: row; justify-content: center;">
                <div><a href="https://www.essilor.com/in-en/innovation/" target="_blank">
                        <h2>Digital Transformation &nbsp;</h2>
                    </a></div>
                <div style="margin-top: 4px;">
                    <a href="https://www.essilor.com/in-en/innovation/" target="_blank"><span
                            class="material-symbols-outlined" style="font-size: 35px; font-weight: 600;">
                            arrow_outward
                        </span></a>
                </div>
            </div>
        </div>
 -->

        <div class="scrives-item-2 mt-4 ">
            <div class="row align-items-center">
                <div class="col-12 col-md-6 d-flex justify-content-center align-items-center">
                    <div class="services-img mb-qc ios-content">
                        <div class="image-wrapper">
                            <!--   <div class="background-shape shape1"></div>
                            <div class="background-shape shape2"></div> -->
                            <img src="assets/images/solutions-details/12.png" alt="Person">
                        </div>
                    </div>
                </div>

                <div class="col-lg-6">
                    <h3>About Customer</h3>
                    <p>One of the leading lens manufacturers in the world of vision technology, This organisation is the
                        world’s largest private optical and ophthalmic
                        research centre, with over 170 years of research and more than 430 scientists,
                        positioning them as a leader in optical innovation.</p>
                    <h3>Business Challenge</h3>
                    <p>Sales and Marketing team faced the challenge of
                        needing a seamless solution to enhance their product presentations, streamline
                        the sharing of product catalogues, and efficiently generate sales orders. The
                        desired outcome was to modernize their sales operations for improved efficiency
                        and customer engagement.</p>
                    <h3>Approach</h3>
                    <p>To address the business challenge, this company decided to equip their
                        Sales and Marketing team with advanced mobile technology to transform their
                        traditional sales processes.</p>
                </div>
            </div>
        </div>

        <br>
        <br>

        <div class="scrives-item-2 mt-4 ">
            <div class="row align-items-center">
                <div class="col-lg-6">

                    <h3>Usage</h3>
                    <p> The company deployed over 400 iPads. These devices were utilized by the
                        Sales and Marketing team to showcase product portfolios and facilitate real-time
                        sales order processing.</p>
                    <h3>Outcomes</h3>
                    <p>The adoption of iPads revolutionized the way this company's Sales and
                        Marketing team operates. This digital transformation is highlighted as important
                        for modernizing sales operations, ultimately enhancing customer engagement
                        and business outcomes.</p>
                    <h3>Apple and Partner solutions demonstrated</h3>
                    <p>Superior Digital enabled Essilor’s digital transformation by supplying 400 iPads and implementing
                        a robust MDM solution to manage devices remotely and distribute product manuals, fact sheets,
                        and business documents seamlessly. We also empowered their content creation workflow by
                        providing Macs to design engaging eBooks for efficient distribution across the iPad fleet.</p>
                </div>

                <div class="col-12 col-md-6 d-flex justify-content-center align-items-center">
                    <div class="services-img mb-qc ios-content">
                        <div class="image-wrapper">
                            <!--  <div class="background-shape shape1"></div>
                            <div class="background-shape shape2"></div> -->
                            <img src="assets/images/solutions-details/10.png" alt="Person">
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- <div class="scrives-item-3 mt-4">
            <div class="row align-items-center">
                <div class="col-lg-12">
                    <h3>Conclusion</h3>
                    <p>Essilor’s adoption of iPads highlights the importance of digital tools in modernising sales operations, ultimately enhancing customer engagement and business outcomes.</p>   
                </div>
            </div>
        </div> -->
        <br>
        <br>
        <span style="font-size: 14px; color: #f10909; text-align: center;">Disclaimer: Company names have been withheld
            due to copyright and legal approvals, but full details can be shared upon request.</span>
    </div>
</section>